import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GeocodingApiErrorContextService {
    private suppressGlobalError = false;

    markForSuppression(): void {
        this.suppressGlobalError = true;
    }

    consumeSuppression(): boolean {
        if (!this.suppressGlobalError) {
            return false;
        }

        this.suppressGlobalError = false;
        return true;
    }
}
